<template>
  <div v-if="opts" class="video-modal">
    <div class="close" @click="close()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.22037 1.28002C-0.0734566 0.986194 -0.0734566 0.511071 0.22037 0.22037C0.514196 -0.0703308 0.98932 -0.0734566 1.28002 0.22037L6 4.94035L10.72 0.22037C11.0138 -0.0734566 11.4889 -0.0734566 11.7796 0.22037C12.0703 0.514196 12.0735 0.98932 11.7796 1.28002L7.05965 6L11.7796 10.72C12.0735 11.0138 12.0735 11.4889 11.7796 11.7796C11.4858 12.0703 11.0107 12.0735 10.72 11.7796L6 7.05965L1.28002 11.7796C0.986194 12.0735 0.511071 12.0735 0.22037 11.7796C-0.0703308 11.4858 -0.0734566 11.0107 0.22037 10.72L4.94035 6L0.22037 1.28002Z" fill="white"/>
      </svg>
    </div>

    <transition name="slide-up">
      <div v-show="isEnd" class="video-end">
        <div class="end-controls">
          <button class="end-btn" @click="rewatch()">
            <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.81406 8L7.875 2.097V13.903L1.81406 8ZM8.7082 0.115043C8.19141 -0.109935 7.59023 0.000768383 7.18242 0.397159L0.432422 6.96796C0.158203 7.23936 0 7.61075 0 8C0 8.38925 0.158203 8.76064 0.432422 9.03204L7.18242 15.6028C7.59023 15.9992 8.18789 16.1099 8.7082 15.885C9.22852 15.66 9.5625 15.1422 9.5625 14.5708V9.70341L15.6199 15.5993C16.0277 15.9957 16.6254 16.1064 17.1457 15.8814C17.666 15.6564 18 15.1422 18 14.5708V1.4292C18 0.857829 17.6625 0.340021 17.1457 0.115043C16.6289 -0.109935 16.0277 0.000768383 15.6199 0.397159L9.5625 6.29659V1.4292C9.5625 0.857829 9.225 0.340021 8.7082 0.115043ZM16.3125 13.903L10.2516 8L16.3125 2.097V13.903Z" fill="white"/>
            </svg>
            <span>Watch again</span>
          </button>
          <button class="end-btn" @click="done()">
            <span>Done</span>
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.7741 6.21617C18.0753 6.53643 18.0753 7.01681 17.7741 7.30504L8.93977 15.7598C8.60513 16.0801 8.10318 16.0801 7.80201 15.7598L3.25098 11.4043C2.91634 11.1161 2.91634 10.6357 3.25098 10.3475C3.55215 10.0272 4.0541 10.0272 4.35527 10.3475L8.33742 14.1585L16.6364 6.21617C16.9375 5.92794 17.4395 5.92794 17.7407 6.21617H17.7741Z" />
            </svg>
          </button>
        </div>
      </div>
    </transition>

    <div class="video-player-wrapper">
      <video
        ref="video"
        autoplay="autoplay"
        playsinline
        webkit-playsinline
        preload="metadata" 
        :poster="videoPoster"
        class="video-player"
        @ended="onEnded"
      >
        <source :src="opts.src" type="video/mp4" />
      </video>

      <div class="controls">
        <button class="control-btn" @click="share()">
          <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5764 5.86154C12.0699 5.86154 12.4669 5.46949 12.4669 4.98218V2.58595L16.9713 7.03401L12.4669 11.4821V9.08583C12.4669 8.59852 12.0699 8.20648 11.5764 8.20648H7.12396C4.66768 8.20648 2.59728 9.84427 1.97393 12.072C1.85149 11.6176 1.78099 11.112 1.78099 10.5514C1.78099 7.96099 3.90704 5.86154 6.53029 5.86154H11.5764ZM10.6859 9.96518V12.8964C10.6859 13.369 10.9753 13.7977 11.4206 13.9809C11.8658 14.1641 12.3742 14.0615 12.7155 13.7281L18.6522 7.86573C19.116 7.40773 19.116 6.66394 18.6522 6.20595L12.7155 0.343599C12.3742 0.00651377 11.8658 -0.0924135 11.4206 0.090785C10.9753 0.273983 10.6859 0.699004 10.6859 1.17166V4.10283H6.53029C2.92379 4.10283 0 6.99004 0 10.5514C0 13.4093 1.43221 15.1753 2.54904 16.1243C2.70117 16.2526 2.84958 16.3661 2.98316 16.4651C3.10189 16.553 3.2132 16.6263 3.31338 16.6922C3.48035 16.8021 3.62134 16.8791 3.7141 16.9304C3.80686 16.9817 3.91076 17 4.01465 17C4.41908 17 4.74559 16.6739 4.74559 16.2782C4.74559 16.029 4.61202 15.7946 4.43763 15.615C4.41908 15.5967 4.40424 15.582 4.38569 15.5637C4.29664 15.4795 4.19646 15.3769 4.09999 15.2486C4.03691 15.1644 3.97383 15.0654 3.91447 14.9592C3.71781 14.6038 3.56198 14.1201 3.56198 13.4863C3.56198 11.5444 5.15745 9.96884 7.12396 9.96884H10.6859V9.96518Z" fill="white"/>
          </svg>
        </button>

        <button class="control-btn" @click="like()">
          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.57851 1.374C7.31487 0.141763 8.87963 -0.353964 10.2072 0.269235L10.4621 0.40379C11.6941 1.14384 12.1897 2.70892 11.5666 4.03676L11.0675 5.09903H14.9511L15.213 5.11319C16.4981 5.2442 17.5 6.33126 17.5 7.64848C17.5 8.11588 17.3726 8.54787 17.1531 8.9232C17.369 9.29854 17.4965 9.73053 17.5 10.1979C17.5 10.8459 17.2557 11.4302 16.8628 11.8799C16.9088 12.0675 16.9336 12.2623 16.9336 12.4641C16.9336 13.3529 16.4769 14.1283 15.7936 14.5851C15.7264 15.8421 14.7528 16.8584 13.5137 16.9823L13.2518 16.9965H9.56643C8.9292 16.9965 8.2955 16.8761 7.70429 16.6459L7.45294 16.5397L7.42815 16.5291L7.1945 16.4158L7.16972 16.4051L6.73782 16.175C6.30237 15.9448 5.91295 15.6545 5.57309 15.3216C5.42795 16.2741 4.60662 17 3.61537 17H2.48251C1.38859 17 0.5 16.1112 0.5 15.0171L0.50708 7.08193C0.50708 5.98779 1.39567 5.09903 2.48959 5.09903H3.62245C4.00479 5.09903 4.36235 5.2088 4.66681 5.4L6.44044 1.62894L6.46168 1.58645L6.55727 1.40941L6.57851 1.37754V1.374ZM2.48959 6.79866C2.33382 6.79866 2.20637 6.92613 2.20637 7.08193V15.0136C2.20637 15.1694 2.33382 15.2968 2.48959 15.2968H3.62245C3.77822 15.2968 3.90566 15.1694 3.90566 15.0136V7.08193C3.90566 6.92613 3.77822 6.79866 3.62245 6.79866H2.48959ZM9.48501 1.80599C8.96106 1.56166 8.34152 1.74933 8.04415 2.2309L7.96626 2.37253L5.95543 6.65348C5.83153 6.91905 5.76072 7.20232 5.74302 7.49268L5.73948 7.6414V11.6391L5.74656 11.9188C5.83153 13.0767 6.50417 14.1177 7.54144 14.6701L7.94856 14.8861L8.17159 14.9959C8.61058 15.1941 9.08496 15.2968 9.56643 15.2968H13.2518L13.3367 15.2933C13.7651 15.2508 14.1014 14.8861 14.1014 14.447L14.0943 14.3549C14.0908 14.3231 14.0873 14.2948 14.0802 14.2629C13.9846 13.8344 14.2324 13.406 14.6466 13.2714C14.99 13.1617 15.2343 12.8394 15.2343 12.4641C15.2343 12.3118 15.1953 12.1738 15.1245 12.0463C14.9015 11.6532 15.0254 11.154 15.4077 10.9132C15.6485 10.7609 15.8042 10.4954 15.8042 10.1979C15.8042 9.94652 15.6945 9.71991 15.514 9.56056C15.3299 9.39768 15.2237 9.16752 15.2237 8.9232C15.2237 8.67888 15.3299 8.44872 15.514 8.28584C15.6945 8.1265 15.8042 7.89988 15.8042 7.64848L15.8007 7.5635C15.7618 7.16337 15.4431 6.84469 15.0431 6.80574L14.9581 6.8022H9.73636C9.44606 6.8022 9.17701 6.65348 9.02124 6.40916C8.86547 6.16484 8.84423 5.85324 8.96814 5.59121L10.0302 3.31441C10.278 2.78328 10.0798 2.15654 9.58767 1.86264L9.48501 1.80599Z" fill="white"/>
          </svg>
        </button>

        <button class="control-btn" @click="sound()">
          <svg v-if="isMuted" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.43175 0C9.0809 0 8.74872 0.140402 8.49865 0.390848L4.10936 4.85714H1.79155C0.802463 4.85714 0 5.67299 0 6.67857V10.3214C0 11.327 0.802463 12.1429 1.79155 12.1429H4.10936L8.50238 16.6092C8.74872 16.8596 9.08463 17 9.43548 17C10.1633 17 10.753 16.4004 10.753 15.6605V1.33951C10.7493 0.599554 10.1596 0 9.43175 0ZM5.11337 6.41295L8.95773 2.50446V14.4993L5.11337 10.5908C4.94541 10.4201 4.71774 10.3252 4.47887 10.3252H1.79155V6.68237H4.47887C4.71774 6.68237 4.94541 6.5875 5.11337 6.41674V6.41295ZM13.6979 5.42634C13.347 5.78304 13.347 6.35982 13.6979 6.71272L15.4521 8.49621L13.6979 10.2797C13.347 10.6364 13.347 11.2132 13.6979 11.5661C14.0487 11.919 14.616 11.9228 14.9631 11.5661L16.7174 9.78259L18.4716 11.5661C18.8224 11.9228 19.3898 11.9228 19.7369 11.5661C20.084 11.2094 20.0877 10.6326 19.7369 10.2797L17.9826 8.49621L19.7369 6.71272C20.0877 6.35603 20.0877 5.77924 19.7369 5.42634C19.386 5.07344 18.8187 5.06964 18.4716 5.42634L16.7174 7.20982L14.9631 5.42634C14.6123 5.06964 14.045 5.06964 13.6979 5.42634Z" fill="white"/>
          </svg>

          <svg v-else width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.37754 0C9.02871 0 8.69844 0.140402 8.44981 0.390848L4.08574 4.85714H1.78125C0.797852 4.85714 0 5.67299 0 6.67857V10.3214C0 11.327 0.797852 12.1429 1.78125 12.1429H4.08574L8.45352 16.6092C8.69844 16.8596 9.03242 17 9.38125 17C10.1049 17 10.6912 16.4004 10.6912 15.6605V1.33951C10.6875 0.599554 10.1012 0 9.37754 0ZM5.08398 6.41295L8.90625 2.50446V14.4993L5.08398 10.5908C4.91699 10.4201 4.69063 10.3252 4.45312 10.3252H1.78125V6.68237H4.45312C4.69063 6.68237 4.91699 6.5875 5.08398 6.41674V6.41295ZM16.3689 2.84598C15.9867 2.52723 15.4264 2.58795 15.1146 2.97879C14.8029 3.36964 14.8623 3.94263 15.2445 4.26138C16.4506 5.26317 17.2188 6.78862 17.2188 8.5C17.2188 10.2114 16.4506 11.7368 15.2445 12.7424C14.8623 13.0612 14.8066 13.6342 15.1146 14.025C15.4227 14.4158 15.9867 14.4728 16.3689 14.1578C17.9721 12.8221 19 10.7844 19 8.50379C19 6.22321 17.9721 4.18549 16.3689 2.84978V2.84598ZM14.1238 5.67299C13.7416 5.35424 13.1812 5.41496 12.8695 5.8058C12.5578 6.19665 12.6172 6.76964 12.9994 7.08839C13.4002 7.42232 13.6562 7.9308 13.6562 8.5C13.6562 9.0692 13.4002 9.57768 12.9994 9.9154C12.6172 10.2342 12.5615 10.8071 12.8695 11.198C13.1775 11.5888 13.7416 11.6458 14.1238 11.3308C14.9217 10.6592 15.4375 9.64219 15.4375 8.5C15.4375 7.35781 14.9217 6.34085 14.1201 5.67299H14.1238Z" fill="white"/>
          </svg>
        </button>

        <button class="control-btn" @click="rewind()">
          <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.81406 8L7.875 2.097V13.903L1.81406 8ZM8.7082 0.115043C8.19141 -0.109935 7.59023 0.000768383 7.18242 0.397159L0.432422 6.96796C0.158203 7.23936 0 7.61075 0 8C0 8.38925 0.158203 8.76064 0.432422 9.03204L7.18242 15.6028C7.59023 15.9992 8.18789 16.1099 8.7082 15.885C9.22852 15.66 9.5625 15.1422 9.5625 14.5708V9.70341L15.6199 15.5993C16.0277 15.9957 16.6254 16.1064 17.1457 15.8814C17.666 15.6564 18 15.1422 18 14.5708V1.4292C18 0.857829 17.6625 0.340021 17.1457 0.115043C16.6289 -0.109935 16.0277 0.000768383 15.6199 0.397159L9.5625 6.29659V1.4292C9.5625 0.857829 9.225 0.340021 8.7082 0.115043ZM16.3125 13.903L10.2516 8L16.3125 2.097V13.903Z" fill="white"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import API from 'app/axios';

  export default {    
    data() {
      return {
        isEnd: false,
        isMuted: true,
        duration: 0,
        intervals: [],
      }
    },

    props: {
      opts: {
        type: Object,
        default: null
      },
    },

    mounted () {
      if (this.$refs.video) {
        const video = this.$refs.video;
        video.muted = this.muted;
        this.isMuted = this.muted;

        video.addEventListener('loadedmetadata', () => {
          this.duration = video.duration;

          const segment = this.duration / 5;

          this.intervals = Array.from({ length: 5 }, (_, i) => ({
            interval: i + 1,
            time: segment * (i + 1),
            read: false,
          }));
        });

        video.addEventListener('timeupdate', () => {
          const currentTime = video.currentTime;

          this.intervals.forEach((item) => {
            if (!item.read && currentTime >= item.time) {
              item.read = true;
              this.onIntervalReached(item);
            }
          });
        });
      }
    },

    computed: {
      hasApp() {
        return this.$store.getters.hasApp;
      },

      isDesktop() {
        return this.$layoutEngine.isDesktop;
      },

      muted() {
        return this.$userEngine.getPref('layout.media.mute');
      },

      stackSlug() {
        return this.$route?.params?.slug; 
      },

      stack() {
        return this.$store.getters.getStack(this.stackSlug);
      },

      videoPoster() {
        const size = this.isDesktop ? 'wide' : 'tall';
        let video = this.opts?.meta?.vfx?.thumbs?.[size];
        return video ? video : "https://nourished.news/r/x/pix.gif";
      },
    },

    methods: {
      close() {
        API.getStackShelves();
        this.$emit('close');
        this.EventBus.$emit('full:video:close')
      },

      sound() {
        const video = this.$refs.video;
        video.muted = !video.muted;
        this.isMuted = video.muted;
        this.$userEngine.setPref('layout.media.mute', video.muted);
        this.EventBus.$emit('track:event', {
          event: 'channel-video-sound',
          props: { mode: video.muted ? 'Mute' : 'Unmute' },
          detail: { detail_char: video.muted ? 'Mute' : 'Unmute' },
        });
      },

      onEnded() {
        this.isEnd = true;
      },

      rewind() {
        const video = this.$refs.video;
        if (video && video.currentTime) {
          video.currentTime = Math.max(video.currentTime - 10, 0);
        }
      },

      done() {
        this.close();
        this.EventBus.$emit('swiper:outro')
      },

      rewatch() {
        this.isEnd = false;
        const video = this.$refs.video;
        if (video) {
          video.currentTime = 0;
          video.play();
        }
        this.EventBus.$emit('track:event', {
          event: 'channel-rewatch',
          props: { mode: this.stack?.meta?.name },
          detail: { detail_char: this.stack?.meta?.name },
        });
      },

      onIntervalReached(item) {
        const card = this.stack?.structure[item.interval];

        let oPayload = {};
        oPayload.feature = /^pattern/.test(this.stackSlug) ? this.stackSlug.replace(/pattern:/, '') : `:${this.stackSlug}`;
        oPayload.edition = this.stack?.meta?.edition?.slug;
        oPayload.card = card.slug;
        oPayload.time = Math.ceil(item.time);
        this.$userEngine.stackRead(oPayload);
      },

      like() {
        this.EventBus.$emit('layer:new', {
          component: 'message',
          opts: {
            heading: `Likes are on their way!`,
            message: `We're still building this feature, but we're happy you like ${this.opts.meta?.name}!`,
            action: {
              type: 'close',
              label: 'Ok!'
            }
          },
        });
      },

      share() {
        if (this.hasApp) {
          this.EventBus.$emit("appCallback", {
            type: 'socialCallback',
            data: {
              social: 'url',
              link: `https://nourished.news/n/${this.opts.meta.slug}`,
            }
          });
          return;
        } else {
          this.EventBus.$emit('layer:new', {
            component: 'message',
            opts: {
              heading: `Spread the love`,
              message: `Know someone who'd enjoy ${this.opts.meta?.name}? Help them discover a better news.`,
              share: {
                url: `https://nourished.news/n/${this.opts.meta.slug}`,
                message: this.opts.meta?.edition?.synopsis,
              }
            },
          });
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .video-modal {
    position: absolute;
    // top: calc(env(safe-area-inset-top) + 1.5rem);
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    // height: 100%;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    overflow: hidden;

    .desktop & {
      max-width: 900px;
      top: 1.5rem;
      margin: 0 auto;
    }

    .close {
      position: absolute;
      top: 0.75rem;
      right: 0.75rem;
      z-index: 10;
      cursor: pointer;
    }

    .close,
    .control-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: flex-end;
      width: 44px;
      height: 44px;
      background: none;

      svg {
        filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.6))
                drop-shadow(0 3px 6px rgba(0, 0, 0, 0.3));
      }
    }

    .control-btn {
      padding: 0 1px 1px 0;
    }

    .controls {
      position: absolute;
      right: 0.5rem;
      z-index: 10;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      top: 0;
      bottom: 0;
      align-self: center;
    }

    .video-end {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgba($neutral-100, 0.95);
      backdrop-filter: blur(5px);
      z-index: 20;
      padding: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;

      .end-controls {
        display: flex;
        width: 100%;
        gap: 1.5rem;

        .end-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1rem;
          text-align: center;
          padding: 0;
          color: $neutral-600;
          width: 100%;
          height: 3rem;
          border: 1px solid rgba($neutral-400, 0.25);
          border-radius: 500px;
          background: none;

          svg {
            fill: $neutral-600;
            margin-bottom: 2px;
          }
        }
      }
    }

    .video-player-wrapper {
      position: relative;
      background: black;

      .desktop & {
        background: $neutral-200;
      }
    }

    .video-player {
      // height: 100%;
      width: 100%;
      background: black;

      .desktop & {
        background: $neutral-200;
      }
    }
  }

  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: all 0.2s ease-in-out;
  }

  .slide-up-enter,
  .slide-up-leave-to {
    opacity: 0;
    transform: translateY(0px);
  }
</style>